import { hvarServiceApi } from '@/shared/api/hvar-service.api';

import { GetYachtFeatureFlagsVariables, YachtFeatureFlagsResponse } from '../model/types/feature-flags.interface';

const featureFlagsApi = hvarServiceApi.injectEndpoints({
	endpoints: (build) => ({
		getYachtFeatureFlags: build.query<string[], GetYachtFeatureFlagsVariables>({
			query: ({ yachtId, page, size }) => {
				const params = new URLSearchParams({
					page: String(page),
					size: String(size),
				});

				params.append('yacht_ids', yachtId);

				return {
					method: 'GET',
					url: `feature_flags?${params.toString()}`,
				};
			},
			transformResponse: (response: YachtFeatureFlagsResponse, _, { yachtId }): string[] =>
				Array.from(
					new Set(
						response.items
							.filter(({ yacht_id: responseYachtId }) => responseYachtId === null || responseYachtId === yachtId)
							.flatMap(({ enabled_features: enabledFeatures }) => enabledFeatures),
					),
				),
		}),
	}),
});

export const { useGetYachtFeatureFlagsQuery } = featureFlagsApi;
